import { render, staticRenderFns } from "./download5.vue?vue&type=template&id=62b5bb3c&scoped=true&"
import script from "./download5.vue?vue&type=script&lang=js&"
export * from "./download5.vue?vue&type=script&lang=js&"
import style0 from "./download5.vue?vue&type=style&index=0&id=62b5bb3c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b5bb3c",
  null
  
)

export default component.exports